export default __webpack_public_path__ + "static/media/nobill.c3878316.png";